import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a9e8f3f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "コミュニティ内でのユーザの活動情報を確認することができます。 ", -1))
const _hoisted_4 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7 mt-5" }
const _hoisted_5 = { class: "w-max-content col-lg-2" }
const _hoisted_6 = { class: "col-lg-10" }
const _hoisted_7 = { class: "title-history mb-1 me-1 d-flex justify-content-center align-items-center" }
const _hoisted_8 = { class: "title-content mb-1 d-flex ps-5 align-items-center" }
const _hoisted_9 = { class: "border-bottom row mx-0 px-0 pb-4 gx-3 mb-4 fs-7" }
const _hoisted_10 = { class: "w-max-content col-lg-2" }
const _hoisted_11 = { class: "col-lg-10" }
const _hoisted_12 = ["href", "onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, /*#__PURE__*/_toDisplayString('▶'), -1))
const _hoisted_14 = {
  key: 0,
  class: "status fw-bold text-white ms-4 align-items-center d-flex justify-content-center"
}
const _hoisted_15 = { class: "d-flex justify-content-center" }

import { PropType, ref, watchEffect } from 'vue'
import { useRouter } from 'vue-router'

import { translate } from '@/languages/i18n'
import Button from '@/components/button/index.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Object as PropType<{
    posts: {
      article: number
      recruitment: number
    }
    post_likes: {
      article: number
      recruitment: number
      offer: number
    }
    post_comments: {
      article: number
      recruitment: number
      offer: number
    }
    invited_count: number
    post_reactions_count: number
    topic_count: number
    login_count: number
    groups: any[]
  }>,
},
  setup(__props) {

const props = __props

const router = useRouter()



const histories = ref<any[]>([])

watchEffect(() => {
  histories.value = [
    {
      id: '1',
      title: translate('OE30numberPost'),
      content: `${Number(props.data?.posts?.article) + Number(props.data?.posts?.recruitment)}（${translate('article')}：${props.data?.posts?.article}   ${translate(
        'recruitment'
      )}：${props.data?.posts?.recruitment}）`,
    },
    {
      id: '2',
      title: translate('OE30numberLikes'),
      content: `${Number(props.data?.post_likes?.article) + Number(props.data?.post_likes?.offer) + Number(props.data?.post_likes?.recruitment)}（${translate('article')}：${
        props.data?.post_likes?.article === null ? 0 : props.data?.post_likes?.article
      }   ${translate('recruitment')}：${props.data?.post_likes?.recruitment === null ? 0 : props.data?.post_likes?.recruitment}   ${translate('jobOffer')}：${
        props.data?.post_likes?.offer === null ? 0 : props.data?.post_likes?.offer
      }）`,
    },
    {
      id: '3',
      title: translate('OE30numberComments'),
      content: `${Number(props.data?.post_comments?.article) + Number(props.data?.post_comments?.offer) + Number(props.data?.post_comments?.recruitment)}（${translate(
        'article'
      )}：${props.data?.post_comments?.article === null ? 0 : props.data?.post_comments?.article}   ${translate('recruitment')}：${
        props.data?.post_comments?.recruitment === null ? 0 : props.data?.post_comments?.recruitment
      }   ${translate('jobOffer')}：${props.data?.post_comments?.offer === null ? 0 : props.data?.post_comments?.offer}）`,
    },
    {
      id: '4',
      title: translate('OE30numberInvitations'),
      content: props.data?.invited_count,
    },
    {
      id: '5',
      title: translate('OE30numberChatRemarks'),
      content: props.data?.chat_count,
    },
    {
      id: '6',
      title: translate('OE30numberTopicRemarks'),
      content: props.data?.topic_count,
    },
    {
      id: '7',
      title: translate('OE30loginCount'),
      content: props.data?.login_count,
    },
  ]
})
const backToList = () => {
  router.push(`/community/communities/${router.currentRoute.value.params?.id}/alumnus?management_no=desc`)
}

const transitTalkRooms = (groupID: string) => {
  router.push(`/community/communities/${router.currentRoute.value.params?.id}/admin/groups/${groupID}/talkrooms`)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_unref(translate)('OE30activeInformation')), 1),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(translate)('OE30actionHistory2')), 1),
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(histories.value, (history) => {
          return (_openBlock(), _createElementBlock("div", {
            key: history.id,
            class: "d-flex"
          }, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(history.title), 1),
            _createElementVNode("div", _hoisted_8, _toDisplayString(history.content), 1)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("label", _hoisted_10, _toDisplayString(_unref(translate)('OE30participantGroup')), 1),
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data?.groups, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "d-flex align-items-center mb-3",
            key: index
          }, [
            _createElementVNode("div", {
              class: "text-decoration-underline cursor-pointer hover-link",
              "data-bs-toggle": "collapse",
              href: `#collapseExample${item.id + index}`,
              onClick: () => transitTalkRooms(item.id)
            }, [
              _hoisted_13,
              _createTextVNode(_toDisplayString(item?.name), 1)
            ], 8, _hoisted_12),
            (item?.is_admin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_unref(translate)('creator')), 1))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createVNode(Button, {
        title: _unref(translate)('back'),
        type: 'secondary',
        onClick: backToList
      }, null, 8, ["title"])
    ])
  ]))
}
}

})